export const REQUEST_CANCELLED = 'REQUEST_CANCELLED';
const REQ_CANCELLED_BY_USER = 'Request cancelled by User';

export const createRequestCancellationError = () => {
  return {
    message: REQUEST_CANCELLED
  };
};

export const requestCancellationErrorHandler = (err) => {
  if (err.message === REQUEST_CANCELLED) {
    console.warn(REQ_CANCELLED_BY_USER);
  } else {
    throw err;
  }
};
